import * as React from 'react';
import TrackingModel from 'src/model/trackingInfo.model';
import EmptyTracking from 'src/components/TrackingInfo/components/EmptyTracking';
import TrackingCard from './components/TrackingMobileCard';

export interface ITrackProps {
  headers: Array<{ label: string; sortBy: string; key: string }>;
  trackings: TrackingModel[];
}

class TrackingMobileTable extends React.Component<ITrackProps, any> {
  private renderCards = () => {
    const cards: JSX.Element[] = [];
    this.props.trackings.map((tracking, index) => {
      cards.push(
        <TrackingCard
          key={index}
          headers={this.props.headers}
          tracking={tracking}
        />
      );
    });
    return cards;
  };

  public render() {
    if (this.props.trackings.length === 0) {
      return (
        <React.Fragment>
          <br />
          <div className="rp-tracking-table-empty">
            <EmptyTracking />
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <div className="rp-mobile-tracking-table">{this.renderCards()}</div>
      );
    }
  }
}

export default TrackingMobileTable;
